/*
 * Get an authentication (access & identity) token
 */

import jsonwebtoken from 'jsonwebtoken';

export default async function getAuthToken(apiBaseUrl, username, passwordRaw) {
  const LOGON_URL = `${apiBaseUrl}/token`;
  const PK_URL = `${apiBaseUrl}/.well-known/jwpub.pem`;
  let pubKeyStr = sessionStorage.getItem('PUBLIC_KEY');
  let claims;
  let tokens = {};

  // Get public key
  if (pubKeyStr == null) {
    const pubKeyReq = await fetch(PK_URL, {
      method: 'GET',
      cache: 'no-store',
    }).catch(() => {
      return false;
    });
    pubKeyStr = await pubKeyReq.text();
    sessionStorage.setItem('PUBLIC_KEY', pubKeyStr);
  }

  // Get request tokens
  const tokenReq = await fetch(LOGON_URL, {
    method: 'POST',
    cache: 'no-store',
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    body: JSON.stringify({
      username,
      password: passwordRaw,
    }),
  }).catch((e) => {
    return false;
  });

  if (tokenReq.status !== 200) {
    return false;
  }

  tokens = await tokenReq.json();
  try {
    claims = jsonwebtoken.verify(tokens.auth_token, pubKeyStr, {
      algorithms: ['RS256'],
      issuer: 'ptu-hub-api',
    });
  } catch (e) {
    console.log(e);
    return false;
  }

  localStorage.setItem('REFRESH_TOKEN', tokens.refresh_token);
  sessionStorage.setItem('AUTH_TOKEN', tokens.auth_token);
  sessionStorage.setItem('CLAIMS', JSON.stringify(claims));

  return true;
}
